// Depends
import { route, meta } from '@/helpers/routes'
import TenantActive from './tenant/form'

export default [
  route('invite', '/invite', TenantActive, meta('Ativando Cadastro', false, 'guest', true))
]



// WEBPACK FOOTER //
// ./src/app/auth/active/routes.js